import React from 'react';

import Temi from '../assets/Temi1.png';
import Sayo from '../assets/Sayo.png';
import Marta from '../assets/Marta1.png';
import Sam from '../assets/Sam1.png';

const Team = () => {
  return (
    <div className='flex flex-col justify-center items-center w-screen gap-8 lg:h-screen px-24 lg:pb-0 bg-[]' id='team'>
        <span className='lg:text-3xl text-xl font-gilroy lg:font-gilroyy'>Meet the Team</span>
        <div className='flex lg:flex-row flex-wrap lg:gap-10 gap-2 justify-center items-center l'>
            <div className='flex flex-col lg:gap-4 gap-1 drop-shadow-2xl'>
                <span className='lg:w-52 lg:h-[13.5rem] h-60 w-60 '>
                    <img src={Sayo} alt='' className='w-full h-full rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-xl rounded-bl-xl'></img>
                </span>
                <span className='flex flex-col items-center'>
                    <span className='text-3xl font-normal text-[#000000]/80'>Sayo Johnson</span>
                    <span className='text-base font-light text-[#000000]/70'>Brand Strategist</span>
                </span>
            </div>
            <div className='flex flex-col lg:gap-4 gap-1 drop-shadow-2xl'>
                <span className='lg:w-52 lg:h-[13.5rem] h-60 w-60 '>
                    <img src={Temi} alt='' className='w-full h-full rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-xl rounded-bl-xl'></img>
                </span>
                <span className='flex flex-col items-center'>
                    <span className='text-3xl font-normal text-[#000000]/80'>Tijani Temi</span>
                    <span className='text-base font-light text-[#000000]/70'>Brand Strategist</span>
                </span>
            </div>
            <div className='flex flex-col lg:gap-4 gap-1 drop-shadow-2xl'>
                <span className='lg:w-52 lg:h-[13.5rem] h-60 w-60 '>
                    <img src={Sam} alt='' className='w-full h-full rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-xl rounded-bl-xl'></img>
                </span>
                <span className='flex flex-col items-center'>
                    <span className='text-3xl font-normal text-[#000000]/80'>Fayemi Samuel</span>
                    <span className='text-base font-light text-[#000000]/70'>Brand Strategist</span>
                </span>
            </div>
            <div className='flex flex-col lg:gap-4 gap-1 drop-shadow-2xl'>
                <span className='lg:w-52 lg:h-[13.5rem] h-60 w-60 '>
                    <img src={Sam} alt='' className='w-full h-full rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-xl rounded-bl-xl'></img>
                </span>
                <span className='flex flex-col items-center'>
                    <span className='text-3xl font-normal text-[#000000]/80'>Fayemi Samuel</span>
                    <span className='text-base font-light text-[#000000]/70'>Brand Strategist</span>
                </span>
            </div>
        </div>
    </div>
  )
}

export default Team;